(() => {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = () => {
    const gallery = document.querySelector('.hc-main-media');
    if (!gallery || gallery.dataset.hcDepthReady === 'true') return;
    gallery.dataset.hcDepthReady = 'true';

    const controls = document.createElement('div');
    controls.className = 'hc-depth-controls';
    controls.innerHTML = '<button class="hc-depth-button" type="button" data-hc-inspect aria-pressed="false">Inspect print</button>';
    gallery.append(controls);

    const inspectButton = controls.querySelector('[data-hc-inspect]');
    let inspecting = false;

    const setTilt = (x, y) => {
      if (inspecting || reduceMotion) return;
      gallery.style.setProperty('--hc-tilt-x', `${Math.max(-4, Math.min(4, x))}deg`);
      gallery.style.setProperty('--hc-tilt-y', `${Math.max(-5, Math.min(5, y))}deg`);
    };

    const resetTilt = () => setTilt(0, 0);

    gallery.addEventListener('pointermove', event => {
      if (inspecting) return;
      const rect = gallery.getBoundingClientRect();
      setTilt(((event.clientY - rect.top) / rect.height - .5) * -8, ((event.clientX - rect.left) / rect.width - .5) * 10);
    }, { passive: true });
    gallery.addEventListener('pointerleave', resetTilt, { passive: true });
    gallery.addEventListener('pointerup', resetTilt, { passive: true });
    gallery.addEventListener('pointercancel', resetTilt, { passive: true });

    const setInspectionPan = event => {
      if (!inspecting) return;
      const point = event.touches ? event.touches[0] : event;
      const rect = gallery.getBoundingClientRect();
      const x = ((point.clientX - rect.left) / rect.width - .5) * -70;
      const y = ((point.clientY - rect.top) / rect.height - .5) * -70;
      gallery.style.setProperty('--hc-pan-x', `${x}px`);
      gallery.style.setProperty('--hc-pan-y', `${y}px`);
      if (event.cancelable) event.preventDefault();
    };

    inspectButton.addEventListener('click', () => {
      inspecting = !inspecting;
      gallery.classList.toggle('hc-inspect-mode', inspecting);
      inspectButton.setAttribute('aria-pressed', String(inspecting));
      if (!inspecting) {
        gallery.style.removeProperty('--hc-pan-x');
        gallery.style.removeProperty('--hc-pan-y');
      }
    });
    gallery.addEventListener('pointermove', setInspectionPan, { passive: false });
    gallery.addEventListener('touchmove', setInspectionPan, { passive: false });

    document.querySelectorAll('[data-hc-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (inspecting) inspectButton.click();
        gallery.classList.remove('hc-depth-switching');
        requestAnimationFrame(() => gallery.classList.add('hc-depth-switching'));
        setTimeout(() => gallery.classList.remove('hc-depth-switching'), 460);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
